import { NodeViewContent, NodeViewProps, NodeViewWrapper } from '@tiptap/react'
import React, { useCallback, useRef, useState } from 'react'

import TableMenu from '../TableMenu'
import styles from './TableCellNode.module.scss'

import { preventDefault } from '~lib/helpers'
import usePortalRoots from '~lib/hooks/usePortalRoots'

const TableCellNode: React.FC<React.PropsWithChildren<NodeViewProps>> = ({ editor, getPos }) => {
  const { popupRoot } = usePortalRoots()
  const [menuOpened, setMenuOpened] = useState(false)
  const [menuButtonEl, setMenuButtonEl] = useState<HTMLElement>(null)

  const getStartPos = useCallback(() => getPos() + 2, [getPos])
  const cachedPos = useRef(getStartPos())

  function updatePos() {
    cachedPos.current = editor.state.selection.from
  }

  function handleClickWrapper(e: React.MouseEvent) {
    if (editor.isEditable && !menuButtonEl.contains(e.target as Node)) {
      cachedPos.current = getStartPos()
      editor.commands.focus(cachedPos.current)
    }

    updatePos()
  }

  function handleChangeMenuOpened(opened: boolean) {
    setMenuOpened(opened)

    if (!opened) {
      setTimeout(() => {
        editor.commands.focus(cachedPos.current)
      }, 200)
    }
  }

  return (
    <NodeViewWrapper data-node="table-cell">
      <div onMouseDownCapture={handleClickWrapper}>
        <td className={styles.cell} ref={setMenuButtonEl} onContextMenu={preventDefault}>
          <NodeViewContent />
        </td>

        <TableMenu
          className={styles.menu}
          onUpdate={updatePos}
          editor={editor}
          position={cachedPos.current}
          open={menuOpened}
          onChangeOpen={handleChangeMenuOpened}
          anchorEl={menuButtonEl}
          trigger="contextmenu"
          appendTo={popupRoot}
          placement="right-start"
          withScroll={false}
        />
      </div>
    </NodeViewWrapper>
  )
}

export default TableCellNode
